
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    treeList: {
      type: Array,
      default: () => []
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: String,
      default: 'name'
    },
    maxDeep: {
      type: Number,
      default: 3
    },
    checkStrictly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    treeElement (): any {
      return this.$refs.treeElement
    }
  },
  mounted () {
    this.treeElement.setCheckedKeys(this.defaultCheckedKeys)
  },
  methods: {
    getCheckedNodeIds () {
      const checkedKeys = this.treeElement.getCheckedKeys()
      return checkedKeys
    }
  }
})
